import React, {useState} from "react";
import {CircularProgress} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import {makeStyles} from "@material-ui/core/styles";
import {AccountService} from "../../services";
import {setAccountPaymentMethod} from "../../store/actions";
import * as toast from "../../utils/toast";
import {useStore} from "../../store";
import {useSnackbar} from "notistack";
import CreditCardPanel from "./credit-card";

const useStyles = makeStyles((theme) => ({
    mono: {
        fontFamily: '"Courier New", Courier, monospace',
        fontSize: 16,
    },
    creditCard: {
        display: 'flex',
        borderWidth: 1,
        borderRadius: 4,
        marginBottom: 16,
        maxWidth: 350,
    },
}));


const PaymentMethodCard = ({accountId=0, paymentMethod={ id: '', type: '', brand: '', last4: '', expiry: '', name:''}, canRemove=true}) => {
    const classes = useStyles();
    const [state, setState] = useState({fetching: false, isLoaded: true})
    const [, dispatch] = useStore();
    const {enqueueSnackbar} = useSnackbar();     // Snackbar Hook for notifications
    const cardRef = React.createRef();

    const removeCard = (event) => {

        setState({...state, fetching: true})
        AccountService.removePaymentMethod(accountId)
            .then((result) => {
                // Update the global store
                dispatch(setAccountPaymentMethod({
                    id: '', type: '', brand: '', last4: '', expiry: '',
                }))

                // if we're still displaying the card, update the state
                if (cardRef.current) {
                    setState({...state, fetching: false})
                }
            })
            .catch(error => {
                // Notify the user we hit an error
                toast.apiError("Your card could not be removed", error, enqueueSnackbar);
                setState({...state, fetching: false})
            })
    }

    paymentMethod.expiry = paymentMethod.expiry.replace('/20','/')
    if (paymentMethod.expiry.length === 4) {
        paymentMethod.expiry = '0' + paymentMethod.expiry
    }

    return (
        <div ref={cardRef} className={classes.creditCard}>
            <div className="flex flex-col w-full">
                <CreditCardPanel paymentMethod={paymentMethod}/>
                { canRemove ?
                    <div className="flex flex-row border-t p-1">
                        {state.fetching ?
                            <div style={{marginLeft: '8px', marginTop: '5px'}}>
                                <CircularProgress size={18}/>
                            </div>
                            :
                            <Button color="primary" size="small" onClick={removeCard}>
                                Remove Card
                            </Button>
                        }
                    </div>
                    : null
                }
            </div>
        </div>
    )
}

export default PaymentMethodCard